import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogMethodologyComponent } from '../../dialogs/dialog-methodology/dialog-methodology.component';
import { DialogAllDataComponent } from '../../dialogs/dialog-all-data/dialog-all-data.component';
import { DialogResultsComponent } from '../../dialogs/dialog-results/dialog-results.component';

/**
 * EndosigInfoComponent
 * Displays options to select questions from ENDOSIG 2018
 */
@Component({
  selector: 'app-endosig-info',
  templateUrl: './endosig-info.component.html',
  styleUrls: ['./endosig-info.component.scss']
})
export class EndosigInfoComponent {
  /**
   * Constructor of EndosigInfoComponent class
   * @param dialog Angular Material Dialog
   */
  constructor(private dialog: MatDialog) { }

  /** Dialog that shows Cuestionaries of endosig 2018 */
  openQuestions2018(): void {
    const dialogRef = this.dialog.open(DialogAllDataComponent, {
      panelClass: 'dark-themed-dialog',
      width: '700px',
      data: {
        year: 2018,
        url: 'assets/download/Documentación/2018/Docs_cuestionarios_ENDOSIG_2018.zip',
        size: '1.4 MB',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /**
   * Dialog that shows Diferent types of file extensions to download the
   * whole Data from ENDOSIG 2018
   */
  openMethodology2018(): void {
    const dialogRef = this.dialog.open(DialogMethodologyComponent, {
      panelClass: 'dark-themed-dialog',
      width: '700px',
      data: {
        year: 2018,
        csv: 'assets/download/Datos/2018/csv/ENDOSIG_2018_csv.zip',
        sizeCsv: '1.4 MB',
        xlsx: 'assets/download/Datos/2018/xlsx/ENDOSIG_xlsx.zip',
        sizeXlsx: '12.4 MB',
        dta: 'assets/download/Datos/2018/dta/ENDOSIG_2018_DTA_(STATA).zip',
        sizeDta: '3.4 MB',
        variables: 'assets/download/Datos/2018/xlsx/Diccionario_variables_ENDOSIG_2018.xlsx',
        sizeVariables: '328 KB'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /** Dialog that shows Cuestionaries of endosig 2010 */
  openQuestions2010(): void {
    const dialogRef = this.dialog.open(DialogAllDataComponent, {
      panelClass: 'dark-themed-dialog',
      width: '400px',
      data: {
        year: 2010,
        url: 'assets/download/Documentación/2010/Cuestionarios.zip',
        size: '552 KB',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /**
   * Dialog that shows Diferent types of file extensions to download the
   * whole Data from ENDOSIG 2010
   */
  openMethodology2010(): void {
    const dialogRef = this.dialog.open(DialogMethodologyComponent, {
      panelClass: 'dark-themed-dialog',
      width: '700px',
      data: {
        year: 2010,
        dta: 'assets/download/Datos/2010/dta/endosig_2010_06062011.dta.zip',
        sizeDta: '17.5 MB',
        sav: 'assets/download/Datos/2010/sav/ENDOSIG-2010 (07-06-2012) (2).sav.zip',
        sizeSav: '10 MB',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /** Dialog that shows Cuestionaries of endosig 2005 */
  openQuestions2005(): void {
    const dialogRef = this.dialog.open(DialogAllDataComponent, {
      panelClass: 'dark-themed-dialog',
      width: '800px',
      data: {
        year: 2005,
        url: 'assets/download/Documentación/2005/Cuestionarios.zip',
        size: '2.1 MB',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /**
   * Dialog that shows Diferent types of file extensions to download the * whole Data from ENDOSIG 2005
   */
  openMethodology2005(): void {
    const dialogRef = this.dialog.open(DialogMethodologyComponent, {
      panelClass: 'dark-themed-dialog',
      width: '700px',
      data: {
        year: 2005,
        sav: 'assets/download/Datos/2005/sav/ENDOSIG_2005.zip',
        sizeSav: '1.7 MB',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /**
   * Dialog that show OpenResults
   */
  openResults(): void {
    const dialogRef = this.dialog.open(DialogResultsComponent, {
      panelClass: 'dark-themed-dialog',
      width: '500px',
      data: {
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/endosig/endosig-info/endosig-info.component.ts